import { createContext, useState } from "react";
import { useEffectOnce } from "react-use";
import repository from "./LeaveRepository";
export const LeaveContext = createContext();

export const LeaveProvider = ({ children }) => {
  const [dataSource, setDataSource] = useState([]);
  useEffectOnce(async () => {
    const response = await repository.getAllLeave();
    setDataSource(response);
  });

  return (
    <LeaveContext.Provider value={[dataSource, setDataSource]}>
      {children}
    </LeaveContext.Provider>
  );
};
